import { SUPER_ADMIN_ONLY } from "@excel-center/shared";

export { AUDIT_ACTIONS, AUDIT_ENTITY_TYPES, AuditAction, AuditEntityType } from "@excel-center/shared";

export const AUDIT_NAMESPACE = "audit" as const;

export const SUPER_ADMIN_ROLES = SUPER_ADMIN_ONLY;

export const AUDIT_PAGE_SIZE = 50;
export const AUDIT_CSV_PAGE_SIZE = 1000;
export const AUDIT_CSV_ROW_CAP = 10_000;

export const DATE_RANGE_PRESETS = ["7d", "30d", "custom"] as const;
export type DateRangePreset = (typeof DATE_RANGE_PRESETS)[number];
